import { featureToggles } from 'configuration/feature-toggles'

export const isPhoneNumber = (value: string): boolean => REGEX.PHONE_NUMBER.test(value)

const isExcludedPostalCodes = (value: string): boolean => {
  const number = Number(value)
  if (isNaN(number)) {
    return false
  }

  return (
    (number >= 51001 && number <= 51080) || // Ceuta
    (number >= 52000 && number <= 52080) || // Melilla
    (number >= 35000 && number <= 35660) || // Canary Islands 1
    (number >= 38001 && number <= 38917) // Canary Islands 2
  )
}
export const isPostalCode = (value: string): boolean =>
  featureToggles.allowAlternativeShippingState
    ? REGEX.POSTAL_CODE.test(value)
    : REGEX.POSTAL_CODE.test(value) && !isExcludedPostalCodes(value)

export const isFiscalCode = (value: string): boolean =>
  REGEX.FISCAL_CODE.test(value.replace(/ /g, ''))

export const isVatId = (value: string): boolean => REGEX.VAT_CODE.test(value)

export const isDateOfBirth = (value: string): boolean => {
  if (!REGEX.DATELIKE.test(value)) {
    return false
  }

  const [year, month, day] = value.split('-').map((part) => parseInt(part, 10))
  if (!year || !month) {
    return false
  }
  const date = new Date(year, month - 1, day)

  return !isNaN(date.getTime()) && date.getMonth() === month - 1 && date.getDate() === day
}

const REGEX = {
  PHONE_NUMBER: /^\d{9}$/,
  POSTAL_CODE: /^\s?\d{5}\s?$/,
  FISCAL_CODE:
    /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
  VAT_CODE: /^([A-Za-z0-9])[0-9]{7}([A-Za-z0-9])$/,
  DATELIKE: /^\d{4}-\d{1,2}-\d{1,2}$/,
}
